import moment from 'moment'

const prepareShow = alls => {
  return alls
}

export default {
  doLoad () {
    this.$resource.get('')
      .then(({data}) => {
        this.alls = prepareShow({...data})
      })
  },
  dtDay (dt) {
    moment.locale('pt-br')
    return moment(dt, 'YYYYMMDD').format('DD')
  },
  dtYear (dt) {
    moment.locale('pt-br')
    return moment(dt, 'YYYYMMDD').format('YYYY')
  },
  dtMonth (dt) {
    moment.locale('pt-br')
    const mm = moment(dt, 'YYYYMMDD').format('MM')
    return moment.monthsShort('-MMM-', mm)
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/profile/me/components/forall/resources/methods.js